module.exports = __webpack_public_path__ + "static/media/Calibri-light.cd8eb87e.ttf";